import { render } from "./SkeletonMessageText.vue?vue&type=template&id=3112d3ec&scoped=true"
import script from "./SkeletonMessageText.vue?vue&type=script&lang=js"
export * from "./SkeletonMessageText.vue?vue&type=script&lang=js"

import "./SkeletonMessageText.vue?vue&type=style&index=0&id=3112d3ec&scoped=true&lang=css"

import exportComponent from "C:\\Users\\david\\Desktop\\Netloud\\whiteLabel\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3112d3ec"]])

export default __exports__